"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberType = 'number';
exports.isNumericColumnSchema = function (column) {
    return column !== undefined && column.type === exports.NumberType;
};
exports.DateTimeType = 'datetime';
exports.isDateTimeColumnSchema = function (column) {
    return column !== undefined && column.type === exports.DateTimeType;
};
exports.TableCalcType = 'table-calc';
exports.isTableCalcRef = function (calc) {
    return calc !== undefined && calc.type === exports.TableCalcType;
};
exports.isCalculatedColumnSchema = function (column) {
    return column.calculation !== undefined;
};
exports.ConstantType = 'constant';
exports.isConstantColumn = function (calc) {
    return calc !== undefined && calc.type === exports.ConstantType;
};
exports.columnSchemaForRef = function (definition, ref) {
    return definition.schema[ref.column];
};
//# sourceMappingURL=EffectiveDefinition.js.map